import React from "react";

const ConfiguratorStepper = ({
  activeStep = 0,
  selections = {},
  onStepClick,
}) => {
  const steps = [
    { title: "Location Map", key: "country" },
    { title: "Product", key: "product" },
    { title: "Sub Product", key: "subProduct" },
    { title: "Type", key: "type" },
    { title: "Standard / Custom", key: "standardOrCustom" },
    { title: "Custom Configurator", key: "customConfigurator" },
  ];

  return (
    <div className="mb-2" style={{ marginTop: "-35px", overflowX: "auto" }}>
      <div
        className="d-flex justify-content-between align-items-start position-relative"
        style={{ padding: "10px 10px", minWidth: "600px" }}
      >
        {/* Horizontal Line */}
        <div
          className="position-absolute"
          style={{
            top: "25px",
            left: "12%",
            right: "12%",
            height: "1px",
            backgroundColor: "#dee2e6",
            zIndex: 0,
          }}
        />

        {steps.map((step, index) => {
          const active = index === activeStep;
          let value = selections[step.key];

          if (step.key === "standardOrCustom" && value) {
            value = value.charAt(0).toUpperCase() + value.slice(1);
          }

          // A step is completed if it has a valid value
          const completed = Boolean(value);
          // A step is clickable if it's the active step, completed, or if the previous step is completed (so you can click forward to it)
          const isClickable = index === 0 || index === activeStep || completed || Boolean(selections[steps[index - 1]?.key]);

          return (
              <div
                key={index}
                className="text-center position-relative"
                style={{
                  zIndex: 1,
                  minWidth: "90px",
                  cursor: isClickable ? "pointer" : "default"
                }}
                onClick={() => {
                  if (isClickable && onStepClick) {
                    onStepClick(index);
                  }
                }}
              >
              {/* Step Circle */}
              <div
                className="rounded-circle d-flex align-items-center justify-content-center mx-auto"
                style={{
                  width: "30px",
                  height: "30px",
                  fontSize: "12px",
                  fontWeight: "600",
                  backgroundColor: active
                    ? "#dc3545"
                    : completed
                    ? "#198754"
                    : "#ffffff",
                  color:
                    active || completed
                      ? "#ffffff"
                      : "#6c757d",
                  border:
                    active || completed
                      ? "none"
                      : "1px solid #dee2e6",
                }}
              >
                {completed ? "✓" : index + 1}
              </div>

              {/* Step Name */}
              <div
                className={
                  active
                    ? "text-danger fw-semibold"
                    : "text-dark fw-bold"
                }
                style={{
                  fontSize: "14px",
                  marginTop: "4px",
                  lineHeight: "14px",
                }}
              >
                {step.title}
              </div>

              {/* Selected Value */}
              <div
                style={{
                  fontSize: "12px",
                  color: "#212529",
                  marginTop: "2px",
                  lineHeight: "12px",
                  maxWidth: "90px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
                title={value}
              >
                {value || "-"}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ConfiguratorStepper;